module.exports = __webpack_public_path__ + "img/haibao3@2x.df952422.png";